export default "__VITE_ASSET__852d5b5d__"